import type { AllowedCountryCode } from '@nrdy-marketing-engine/cart/@types/cart-state';
import {
  phoneNumberRules,
  zipCodeRules,
} from '@nrdy-marketing-engine/inputs/src/input-validation-rules';
import { useMemo } from 'react';

const useCountryCodedValidations = (countryCode: AllowedCountryCode) => {
  const countryPhoneNumberRules = useMemo(() => phoneNumberRules(countryCode), [countryCode]);
  const countryZipCodeRules = useMemo(() => zipCodeRules(countryCode), [countryCode]);
  const postalCodeLabel = countryCode === 'US' ? 'Zip code' : 'Postal code';

  const countryInputMask = {
    CA: '(+1) 999 999 9999',
    GB: '(+44) 9999 999999',
    US: '(+1) 999 999 9999',
  };

  return {
    countryCode,
    countryInputMask: countryInputMask[countryCode],
    countryPhoneNumberRules,
    countryZipCodeRules,
    postalCodeLabel,
  };
};

export default useCountryCodedValidations;
